import type { FC } from 'react';
import AssignmentForm, { USER_PRINCIPAL_TYPE } from '@/components/AssignmentForm';
import PageContainer from '@ui/PageContainer';
import PageTitle from '@ui/PageTitle';
import useAddUserPage from './useAddUserPage';

const AddUserPage: FC = () => {
	const state = useAddUserPage();

	return (
		<PageContainer>
			<PageTitle>User assignment</PageTitle>
			<AssignmentForm
				state={state}
				fixedPrincipalType={USER_PRINCIPAL_TYPE}
				principalLabel="GUID"
				unavailableNotice="User assignments have no endpoint yet, so this form can't be submitted."
			/>
		</PageContainer>
	);
};

export default AddUserPage;
